import React, { useState } from "react";
import styled from "styled-components";
import { SettingLayout } from "../SettingShell";
import useTriggers from "./hooks/useTriggers";
import OverviewTab from "./components/OverviewTab";
import ConfigureTab from "./components/ConfigureTab";
import EmailConfigureTab from "./components/EmailConfigureTab";
import EmailOverviewTab from "./components/EmailOverviewTab";
import BreachedTriggersTab from "./components/BreachedTriggersTab";
import { FilterGroup, FilterLabel, FilterSelect } from "./styles";

// ─── Tab shell styles ─────────────────────────────────────────────────────────
const TabBar = styled.div`
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  padding: 9px 22px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  background: transparent;
  color: ${({ $active }) => ($active ? "#3f88a5" : "#64748b")};
  border-bottom: 2px solid ${({ $active }) => ($active ? "#3f88a5" : "transparent")};
  margin-bottom: -2px;
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
  &:hover {
    color: #3f88a5;
  }
`;

const TopBar = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

// ─── Component ────────────────────────────────────────────────────────────────
const Triggers = () => {
  const [activeTab, setActiveTab] = useState("configure");

  const hook = useTriggers();
  const {
    financialYears,
    selectedFinancialYear,
    handleFinancialYearChange,
  } = hook;

  const isOverview = activeTab === "overview" || activeTab === "emailOverview" || activeTab === "breaches";

  return (
    <SettingLayout
      $wide
      title="Trigger Configuration"
      subtitle="Set min/max threshold values per KPI and location"
    >
      {/* Shared FY selector — overview tabs only; configure tabs have it as Step 1 */}
      {isOverview && (
        <TopBar>
          <FilterGroup style={{ maxWidth: 220 }}>
            <FilterLabel>Financial Year</FilterLabel>
            <FilterSelect
              value={selectedFinancialYear}
              onChange={(e) => handleFinancialYearChange(e.target.value)}
            >
              <option value="">Select year</option>
              {financialYears.map((fy) => (
                <option key={fy.value} value={fy.value}>
                  {fy.label}
                </option>
              ))}
            </FilterSelect>
          </FilterGroup>
        </TopBar>
      )}

      {/* Tab switcher */}
      <TabBar>
        <Tab $active={activeTab === "configure"} onClick={() => setActiveTab("configure")}>
          Configure
        </Tab>
        <Tab $active={activeTab === "overview"} onClick={() => setActiveTab("overview")}>
          Overview
        </Tab>
        <Tab $active={activeTab === "emailConfigure"} onClick={() => setActiveTab("emailConfigure")}>
          Email Alerts
        </Tab>
        <Tab $active={activeTab === "emailOverview"} onClick={() => setActiveTab("emailOverview")}>
          Email Overview
        </Tab>
        <Tab $active={activeTab === "breaches"} onClick={() => setActiveTab("breaches")}>
          Breached Triggers
        </Tab>
      </TabBar>

      {/* Tab content */}
      {activeTab === "overview" && <OverviewTab hook={hook} />}
      {activeTab === "configure" && <ConfigureTab hook={hook} />}
      {activeTab === "emailConfigure" && <EmailConfigureTab hook={hook} />}
      {activeTab === "emailOverview" && <EmailOverviewTab hook={hook} />}
      {activeTab === "breaches" && <BreachedTriggersTab hook={hook} />}
    </SettingLayout>
  );
};

export default Triggers;
